import React, { useEffect } from 'react';
import { isBlank } from 'utils/helperMethods';
import { head } from 'ramda';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@material-ui/core';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const SelectQuestion = props => {
  const { question, onChange, onValidate, surveyValues } = props;
  const classes = useStyles();
  const field = head(MortgageSurveyQuestionPresenter.surveyValueFields(question));
  const currentValue = MortgageSurveyPresenter[field](surveyValues);

  useEffect(() => {
    const isValid = !isBlank(currentValue);
    onValidate(isValid);
  }, [currentValue]);

  const options = MortgageSurveyQuestionPresenter.options(question);

  const handleSelectValue = value => () => {
    onChange([{ field, value }]);
  };

  return (
    <Box>
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <Box display="flex" maxWidth="900px" width="100%" my={3} flexWrap="wrap" justifyContent="center">
        {options.map(({ label, value }) => {
          const isSelected = currentValue === value;
          return (
            <Button
              key={uuidv4()}
              onClick={handleSelectValue(value)}
              className={clsx(classes.button, { [classes.selected]: isSelected })}
            >
              {label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

SelectQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
};

export default SelectQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/SelectQuestion/SelectQuestion.js